export const landingImage = (fileName) => `${process.env.PUBLIC_URL}/images/landing/${fileName}`;

export const panelPhotoStyle = (fileName) => ({
  backgroundImage: `linear-gradient(180deg, var(--panel-overlay-a), var(--panel-overlay-b)), url(${landingImage(fileName)})`,
});

export const heroBgStyle = {
  backgroundImage:
    "linear-gradient(120deg, var(--hero-overlay-1) 0%, var(--hero-overlay-2) 38%, var(--hero-overlay-3) 100%), url(" +
    landingImage("hero-window.png") +
    ")",
};
